import React from 'react';
import PropTypes from 'prop-types';
import { Typography, FormControlLabel, FormHelperText, FormGroup, Checkbox } from '@material-ui/core';
import { Field } from 'react-final-form';
import FormTextField from './FormTextField';

class FormCheckboxGroup extends React.Component {
  state = {
    selectedValues: [],
  };

  handleChange = value => event => {
    this.setState(
      { selectedValues: event.target.checked ? [...this.state.selectedValues, value] : [...this.state.selectedValues.filter(selected => selected !== value)] },
      () => {
        this.props.input.onChange(this.state.selectedValues);
        this.props.input.onBlur();
      }
    );
  };

  render() {
    const {
      input,
      label,
      meta: { touched, error },
      values,
      disabled,
      allowOwnAnswer,
      ownAnswerName,
      ownAnswerFieldName,
      ...custom
    } = this.props;
    return (
      <React.Fragment>
        {label && <Typography variant="caption" gutterBottom style={error ? { color: 'red' } : {}}>{label}</Typography>}
        <FormGroup
          value={input.value}
          {...custom}
        >
          {values.map(value => (
            <FormControlLabel
              key={value.value}
              value={value.value}
              control={<Checkbox onChange={this.handleChange(value.value)} color="primary" checked={!!input.value && input.value.some(val => val === value.value)} disabled={disabled} />}
              label={value.name}
            />
          ))}
          {allowOwnAnswer &&
            <React.Fragment>
              <FormControlLabel
                value="own"
                control={<Checkbox onChange={this.handleChange("own")} color="primary" checked={input.value && input.value.some(val => val === "own")} disabled={disabled} />}
                label={ownAnswerName}
              />
              {input.value && input.value.some(val => val === "own")
                ? <div>
                    <Field
                      name={ownAnswerFieldName}
                      label={ownAnswerName}
                      placeholder="Wpisz własną odpowiedź"
                      component={FormTextField}
                      disabled={disabled}
                      fullWidth
                    />
                  </div>
                : null}
          </React.Fragment>}
        </FormGroup>
        {touched && error ? <FormHelperText id="checkbox-error-text" error style={{ marginTop: 0 }}>{error}</FormHelperText> : null}
      </React.Fragment>
    );
  }
}

FormCheckboxGroup.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  values: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  allowOwnAnswer: PropTypes.bool,
  ownAnswerName: PropTypes.string,
  ownAnswerFieldName: PropTypes.string,
};

export default FormCheckboxGroup;



// WEBPACK FOOTER //
// ./src/components/form/FormCheckboxGroup.js